




























import { Component, Vue } from "vue-property-decorator";
import { addComment } from "@/req/home";
import starRate from "@/components/starRate.vue";
@Component({
  components: { starRate },
})
export default class Home extends Vue {
  public modal = false;
  public grade: any = 1;
  public content = "";

  public confirmFn: any = null;

  // 显示
  public show(grade) {
    this.grade = grade;
    this.modal = true;
    return new Promise((resolve) => {
      this.confirmFn = () => {
        resolve(1);
      };
    });
  }
  public stopModal() {
    setTimeout(() => {
      if (this.modal === false) {
        this.modal = true;
      }
    });
  }
  public async remove() {
    if (this.content.length < 10) {
      this.$Message.error("评价内容要大于10字");
      return false
    }
    const obj: any = {
      token: this.$fn.cookies.getToken(),
      box_game_id: this.$route.query.id,
      stars_score: this.grade,
      user_name: this.$store.state.user.info.nick_name,
      head_portrait: this.$store.state.user.info.head_img,
      content: this.content,
    };
    const res = await addComment(obj);
    if (res.code == 200) {
      this.modal = false;
      this.$emit("getList");
    } else {
      this.$Message.error(res.msg);
    }
  }
}
